import type { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Overscrollable } from '../../../overscrollable';

import styles from './NavPage.module.css';

export interface NavPageProps extends PropsWithChildren {
  footer?: ReactElement;
}

export const NavPage: FunctionComponent<NavPageProps> = ({ children, footer }) => (
  <div data-testid="nav-page" className={styles.navPage}>
    <Overscrollable>{children}</Overscrollable>
    {footer ? <div data-testid="nav-page-footer" className={styles.navPage__footer}>{footer}</div> : null}
  </div>
);
